module.exports = __webpack_public_path__ + "img/wheat_nss1410.66ddeee8.jpg";